import React from 'react';
import { CTC_COMPONENTS } from '../../../utils/ctcEngine';

const formatINR = (amount) => `₹${Math.round(amount || 0).toLocaleString('en-IN')}`;

// Read-only breakup table for one side (employee or employer). `values` is the
// { [componentId]: annualAmount } map from computeCTC() / a stored offer.ctcBreakup.
const CTCBreakupTable = ({ side, values, total, title }) => {
  const rows = CTC_COMPONENTS.filter(c => c.side === side && (values[c.id] || c.locked));

  return (
    <div className="border border-gray-200 rounded-lg overflow-hidden">
      <div className="bg-gray-50 px-4 py-2 border-b border-gray-200">
        <h4 className="text-sm font-semibold text-gray-800">{title}</h4>
      </div>
      <table className="w-full text-sm">
        <tbody>
          {rows.map(component => (
            <tr key={component.id} className="border-b border-gray-100 last:border-0">
              <td className="px-4 py-2 text-gray-600">{component.label}</td>
              <td className="px-4 py-2 text-right text-gray-900 font-medium">
                {formatINR(values[component.id])}
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr className="bg-gray-50">
            <td className="px-4 py-2 font-semibold text-gray-900">Total</td>
            <td className="px-4 py-2 text-right font-semibold text-gray-900">{formatINR(total)}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default CTCBreakupTable;
